import { useEffect, useState } from 'react';
import { IMerchant } from '~/Models/DTO/Merchant.models';
import { useRequestMerchants } from '~/requests/providerService/useRequestMerchants';
export const useMerchant = () => {
  const [merchantList, setMerchantList] = useState<IMerchant[]>([]);
  const { data } = useRequestMerchants();
  useEffect(() => {
    if (data) {
      setMerchantList(data);
    }
  }, [data?.length]);
  return { merchantList, setMerchantList };
};
